"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useHasChangedUntilCleared", {
    enumerable: true,
    get: function() {
        return useHasChangedUntilCleared;
    }
});
const _react = require("react");
function useHasChangedUntilCleared(value) {
    const prevRef = (0, _react.useRef)(value);
    const [hasChanged, setHasChanged] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        if (prevRef.current !== value) {
            setHasChanged(true);
            prevRef.current = value;
        }
    }, [
        value
    ]);
    const clearChanged = (0, _react.useCallback)(()=>{
        setHasChanged(false);
    }, []);
    return [
        hasChanged,
        clearChanged
    ];
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3V0aWxzL3VzZUhhc0NoYW5nZWRVbnRpbENsZWFyZWQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ2FsbGJhY2ssIHVzZUVmZmVjdCwgdXNlUmVmLCB1c2VTdGF0ZSB9IGZyb20gXCJyZWFjdFwiO1xuXG4vKipcbiAqIFRoaXMgaG9vayBpcyB1c2VkIHRvIGRldGVybWluZSBpZiBhIHZhbHVlIGhhcyBjaGFuZ2VkIHVudGlsIGl0IGlzIGNsZWFyZWQuXG4gKiBcIkNsZWFyaW5nXCIgbWVhbnMgdGhlIGNvbnN1bWVyIGhhcyBhY2tub3dsZWRnZSB0aGUgY2hhbmdlLCBhbmQgdGhlIGN1cnJlbnRseVxuICogcmVmZXJlbmNlZCB2YWx1ZSBpcyBcInN0YWxlXCIuXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiB1c2VIYXNDaGFuZ2VkVW50aWxDbGVhcmVkPFQ+KHZhbHVlOiBUKTogW2Jvb2xlYW4sICgpID0+IHZvaWRdIHtcbiAgY29uc3QgcHJldlJlZiA9IHVzZVJlZjxUPih2YWx1ZSk7XG4gIGNvbnN0IFtoYXNDaGFuZ2VkLCBzZXRIYXNDaGFuZ2VkXSA9IHVzZVN0YXRlKGZhbHNlKTtcblxuICB1c2VFZmZlY3QoKCkgPT4ge1xuICAgIGlmIChwcmV2UmVmLmN1cnJlbnQgIT09IHZhbHVlKSB7XG4gICAgICBzZXRIYXNDaGFuZ2VkKHRydWUpO1xuICAgICAgcHJldlJlZi5jdXJyZW50ID0gdmFsdWU7XG4gICAgfVxuICB9LCBbdmFsdWVdKTtcblxuICBjb25zdCBjbGVhckNoYW5nZWQgPSB1c2VDYWxsYmFjaygoKSA9PiB7XG4gICAgc2V0SGFzQ2hhbmdlZChmYWxzZSk7XG4gIH0sIFtdKTtcblxuICByZXR1cm4gW2hhc0NoYW5nZWQsIGNsZWFyQ2hhbmdlZF07XG59XG4iXSwibmFtZXMiOlsidXNlSGFzQ2hhbmdlZFVudGlsQ2xlYXJlZCIsInZhbHVlIiwicHJldlJlZiIsInVzZVJlZiIsImhhc0NoYW5nZWQiLCJzZXRIYXNDaGFuZ2VkIiwidXNlU3RhdGUiLCJ1c2VFZmZlY3QiLCJjdXJyZW50IiwiY2xlYXJDaGFuZ2VkIiwidXNlQ2FsbGJhY2siXSwibWFwcGluZ3MiOiI7Ozs7K0JBT2dCQTs7O2VBQUFBOzs7dUJBUHlDO0FBT2xELFNBQVNBLDBCQUE2QkMsS0FBUTtJQUNuRCxNQUFNQyxVQUFVQyxJQUFBQSxhQUFNLEVBQUlGO0lBQzFCLE1BQU0sQ0FBQ0csWUFBWUMsY0FBYyxHQUFHQyxJQUFBQSxlQUFRLEVBQUM7SUFFN0NDLElBQUFBLGdCQUFTLEVBQUM7UUFDUixJQUFJTCxRQUFRTSxPQUFPLEtBQUtQLE9BQU87WUFDN0JJLGNBQWM7WUFDZEgsUUFBUU0sT0FBTyxHQUFHUDtRQUNwQjtJQUNGLEdBQUc7UUFBQ0E7S0FBTTtJQUVWLE1BQU1RLGVBQWVDLElBQUFBLGtCQUFXLEVBQUM7UUFDL0JMLGNBQWM7SUFDaEIsR0FBRyxFQUFFO0lBRUwsT0FBTztRQUFDRDtRQUFZSztLQUFhO0FBQ25DIn0=